import React, { useState } from 'react';
import { IconButton, SvgIcon } from '@mui/material';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import PopUp from '../../../../../muiComponents/PopUp';
import useTranslate from '../../../../../customHooks/useTranslate';

const ExcelSvgIcon = (props: React.ComponentProps<typeof SvgIcon>) => {
    return (
        <SvgIcon {...props} viewBox='0 0 192 192'>
            <path
                d='M56 30c0-1.662 1.338-3 3-3h108c1.662 0 3 1.338 3 3v132c0 1.662-1.338 3-3 3H59c-1.662 0-3-1.338-3-3v-32m0-68V30'
                fill='none'
                stroke='currentColor'
                strokeWidth={12}
                strokeLinecap='round'
            />
            <rect
                width={68}
                height={68}
                x={22}
                y={62}
                rx={3}
                fill='none'
                stroke='currentColor'
                strokeWidth={12}
                strokeLinecap='round'
            />
            <path
                d='M138.79 164.725V27.175M56.175 58.792H170M170 96H90.328M169 133.21H56.175M44.5 82l23 28m0-28-23 28'
                fill='none'
                stroke='currentColor'
                strokeWidth={12}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </SvgIcon>
    );
};

const ExportExcelReport = ({ isLoading }: { isLoading: boolean }) => {
    const { handleDownloadExcel, hasUnsavedChanges } = useZitoneoServices();
    const translate = useTranslate();
    const [isWarningOpen, setIsWarningOpen] = useState(false);

    const handleExportClick = () => {
        if (hasUnsavedChanges) {
            setIsWarningOpen(true);
            return;
        }
        handleDownloadExcel();
    };

    return (
        <>
            <IconButton
                onClick={handleExportClick}
                title='Export Excel'
                disabled={isLoading}
            >
                <ExcelSvgIcon
                    className={
                        !isLoading ? 'zitoneo-header__export-icon' : undefined
                    }
                />
            </IconButton>
            <PopUp
                open={isWarningOpen}
                onCancel={() => setIsWarningOpen(false)}
                onSave={async () => {
                    setIsWarningOpen(false);
                    await handleDownloadExcel();
                }}
                cancelText='cancel'
                saveText='continue'
            >
                {translate('export_unsaved_warning')}
            </PopUp>
        </>
    );
};

export default ExportExcelReport;
